// extracted by mini-css-extract-plugin
export default {"userInfo":"userinfo_userInfo__lbIa1","icon":"userinfo_icon__BSIHo","desktopOnly":"userinfo_desktopOnly__6OvaV","avatar":"userinfo_avatar__seGvq"};